import instagram from "../../assets/socialicons/instagram.svg";
import twitter from "../../assets/socialicons/twitter.svg";
import linkedin from "../../assets/socialicons/linkedin.svg";
import styles from "../../styles/Footer.module.scss";

const Footer = ({ title }) => {
  return (
    <div className={styles.footer}>
      <div style={{ display: "flex", flexDirection: "column" }}>
        <div>
          <p>follow me on Social media </p>
          <a href="https://www.instagram.com/riddhisiddarkar/" target="_blank" rel="noreferrer">
            <img src={instagram} alt="instagram" />
          </a>
          <a href="https://twitter.com/siddarkar" target="_blank" rel="noreferrer">
            <img src={twitter} alt="twitter" />
          </a>
          <a
            href="https://in.linkedin.com/in/riddhi-siddarkar-075378191"
            target="_blank" rel="noreferrer"
          >
            <img src={linkedin} alt="linkedin" />
          </a>
          <br />
        </div>
        <span style={{ display: "block", fontSize: 10 }}>Designed by <a href="https://www.linkedin.com/in/dheeraj-gandhi-3257781b1" target="_blank" rel="noreferrer">Dheeraj Gandhi</a></span>
      </div>
      <p>{title}</p>
    </div>
  );
};

export default Footer;
